import {Injectable} from '@angular/core';
import {Subject} from "rxjs/Subject";
import {Observable} from "rxjs/Observable";

import {CustomHttpService} from './custom-http.service';
import {HttpOptionsModel} from '../models';

@Injectable()
export class GameGroupService {

  private currentGameGroups = new Subject();
  private currentGameGroupId = new Subject();
  private  currentBrandId = new Subject();

  constructor(private customHttpService: CustomHttpService){}

  getGameGroups() {
    let httpOptions = new HttpOptionsModel('/game/groups', null, false, true);
    return this.customHttpService.post(httpOptions);
  }
  getCurrentGameGroups():Observable<any>{
    return this.currentGameGroups.asObservable(); 
  }
  setCurrentGameGroups(gameGroup):void{
     this.currentGameGroups.next(gameGroup); 
  }
 
  getGameGroupById(groupId:string){
    var postData = {
      group: groupId
    }
    let httpOptions = new HttpOptionsModel('/group', postData, false, true);
    return this.customHttpService.post(httpOptions);
  }
  getCurrentGameGroupId(): Observable<any> {
    return this.currentGameGroupId.asObservable();
  }
  setCurrentGameGroupId(groupId): void {
    this.currentGameGroupId.next(groupId);
  }

  getBrands(type){
    const postData = {
      type: type
    }
    let httpOptions = new HttpOptionsModel('/site-brand-list', postData, false, true);
    return this.customHttpService.post(httpOptions);
  }
  getCurrentBrandId(): Observable<any>{
    return this.currentBrandId.asObservable();
  }
  setCurrentBrandId(brandId): void{
    this.currentBrandId.next(brandId);
  } 

}



// WEBPACK FOOTER //
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/services/game-group.service.ts